import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as routeBound from '../../../../route-bound'
import * as clusters from '../../clusters'

import { Api } from './api.service'
import associations from './associations'
import * as effects from './effects'
import type { TypeParams } from './types'

/**
 * Occupants collection for fetching space cluster occupants
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams, typeof associations> {
  constructor() {
    const scenarioContext = ngCore.inject(routeBound.scenario.Context.TOKEN)
    const clustersEc = ngCore.inject(clusters.Collection)

    super({
      api: ngCore.inject(Api),
      associations,
      context$: rxjs
        .combineLatest([
          scenarioContext,
          clustersEc.plugins.currentEntityPlugin.feature.selectors.getId()
            .asObservable,
        ])
        .pipe(
          rxjs.map(([context, clusterId]) => {
            if (!context || !ents.extra.space.Cluster.Id.isId(clusterId)) {
              return undefined
            }

            return { ...context, clusterId }
          }),
        ),
      identify: occupant => occupant.employee.id,
      name: ec.Name.Predefined.SpaceClusterOccupant,
    })

    this.feature.registerEffects(effects.reloadOnPayrollsUpdate(this))
  }
}
